/* eslint-disable react/self-closing-comp */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-trailing-spaces */
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  HELP_MODAL_TITLE,
  I_AM_NATALLI,
  CONTACT_US1,
  OR,
  CALL,
  PHONE_NUMBER,
  PHONE_NUM_CALL,
  CONSULT_HOURS,
} from '../../Utils/Constants/GlobalConstants';
import './css/HelpModal.css';
import { ReactComponent as Close } from '../../images/close-r.svg';
import { ReactComponent as Telegram } from '../../images/telegram-white-r.svg';
import { ReactComponent as Instagram } from '../../images/instagram-white-r.svg';
import { ReactComponent as Viber } from '../../images/viber-white-r.svg';
import { changeHelpModalVisibility } from '../../DataStore/actions/modalWindowActions';

const mapStateToProps = (state) => ({ ...state });

class HelpModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { scrollbarWidth: 0 };
  }

  componentDidMount() {
    const scrollWidth =
      window.innerWidth - document.documentElement.clientWidth;
    this.setState({ scrollbarWidth: scrollWidth });
    document.addEventListener('keydown', this.handleEscPress, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscPress, false);
  }

  handleEscPress = (e) => {
    const { helpModalVisible } = this.props;

    if (helpModalVisible && e.key === 'Escape') {
      this.close();
    }
  };

  close = () => {
    const { changeHelpModalVisibility: changeHelpModalVisibilityAction } =
      this.props;

    changeHelpModalVisibilityAction(false);

    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  handleOutCLick = (e) => {
    const className = e.target.className;
    const isSVGIcoClick = e.target.getAttribute('fill') !== null;

    if (
      !this.node.contains(e.target) ||
      className === 'modal_help_social' ||
      className === 'modal_help_phone' ||
      isSVGIcoClick
    ) {
      this.close();
    }
  };

  render() {
    const { scrollbarWidth } = this.state;
    const { helpModalVisible } = this.props;

    if (!helpModalVisible) {
      return null;
    }

    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    return (
      <>
        {helpModalVisible && (
          <div className="modal_help_container" onClick={this.handleOutCLick}>
            <div
              className="modal_help_content"
              ref={(node) => {
                this.node = node;
              }}
            >
              <button
                type="button"
                className="modal_help_close"
                onClick={this.close}
              >
                <Close />
              </button>
              <div className="modal_help_natali"></div>
              <div className="modal_help_text_content">
                <div className="modal_help_title">{HELP_MODAL_TITLE}</div>
                <div className="modal_help_desc">{I_AM_NATALLI}</div>
                <div className="modal_help_contact_us">{CONTACT_US1}</div>
                <div className="modal_help_social_w">
                  <Link
                    target="_blank"
                    to="https://t.me/tourhunter_by"
                    className="modal_help_social"
                  >
                    <Telegram />
                  </Link>
                  <Link
                    target="_blank"
                    to="https://www.instagram.com/tourhunter.by"
                    className="modal_help_social"
                  >
                    <Instagram />
                  </Link>
                  <Link
                    target="_blank"
                    to="viber://chat?number=%2B375296659965"
                    className="modal_help_social"
                  >
                    <Viber />
                  </Link>
                </div>
                <div className="modal_help_or">
                  <div className="modal_help_or_line"></div>
                  <div className="modal_help_text">{OR}</div>
                  <div className="modal_help_or_line"></div>
                </div>
                <div className="modal_help_call">{CALL}</div>
                <a
                  href={`tel:${PHONE_NUM_CALL}`}
                  className="modal_help_phone mb_10"
                >
                  {PHONE_NUMBER}
                </a>
                <div className="gr_text_14 modal_hours">{CONSULT_HOURS}</div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

HelpModal.propTypes = {
  helpModalVisible: PropTypes.bool.isRequired,
  changeHelpModalVisibility: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  changeHelpModalVisibility,
})(HelpModal);
